<script>
  import {
    searchedCustomer,
    searchedCustomerByDateStart,
    searchedCustomerByDateEnd,
  } from '../../utils/store.js';
</script>

<div class="container">
  <div class="row text-center mt-5 flex-row justify-content-evenly">
    <div class="col-md">
      <label for="nameSearch" class="form-label"
        >Müşteri Adı, İlçe ya da Telefon Numarası ile Filtrele</label
      >
      <input
        type="search"
        class="form-control rounded"
        placeholder="Müşteri Filtrele"
        bind:value={$searchedCustomer}
      />
    </div>
    <div class="col-md">
      <label for="dateSearch" class="form-label"
        >Tarih Aralığı ile Filtrele</label
      >
      <div class="d-flex flex-row justify-content-evenly">
        <input
          type="date"
          class="form-control"
          bind:value={$searchedCustomerByDateStart}
        />
        <input
          type="date"
          class="form-control"
          bind:value={$searchedCustomerByDateEnd}
        />
      </div>
    </div>
  </div>
</div>
